// 물리·기하 상수는 전부 여기. 값을 바꾸면 명세 §4.3 표도 같이 고친다.

/** 원작 게임 영역 비율(폭/높이). 영상 854×416 프레임 안의 게임 영역이 x 59..794(736px) — 16:9 에 가깝다. 정규화 좌표는 높이 1 기준. */
export const FRAME_ASPECT = 736 / 416;

/** 월드 높이(m). Box2D 권장 크기(0.1–10m)에 맞춤. */
export const WORLD_H = 10;
export const WORLD_W = FRAME_ASPECT * WORLD_H;

/** 공 반지름(m). 영상 실측 r≈12.9px/416. */
export const BALL_R = 0.31;
/** 선 두께(m). 실측 5.8px/416. */
export const STROKE_T = 0.14;

/** 중력(m/s²). 영상 실측(1판 첫 낙하, tools/trace/calibrate.py): 0.78 화면높이/s²(잔차 0.08px) → ×WORLD_H. */
export const GRAVITY = -0.78 * WORLD_H;

// 원작 손맛: 공은 잘 구르고(마찰 낮음) 선은 무거워 공을 밀어낸다.
// Box2D 는 반발을 max(a, b) 로 섞는다 → 공은 낮게(바닥 낙하 때 거의 안 튐, 실측), 선은 높게(선·공 충돌은 확실히 튐 — 사용자 피드백).
export const BALL = { density: 1.0, friction: 0.25, restitution: 0.1 };
export const STROKE = { density: 2.5, friction: 0.3, restitution: 0.5 };
export const OBSTACLE = { friction: 0.4 };
/** 탄성 면: 두께(m)와 반발. */
export const BOUNCY = { thickness: 0.12, restitution: 1.0, friction: 0.2 };

/** 움직이는 물체(연한 회색). */
export const DYNAMIC = { density: 1.0, friction: 0.3, restitution: 0.1 };
/** 컨베이어 표면 속도(m/s). 영상에서 선이 2초에 ~100px(0.24H) 움직임 → 1.2. */
export const CONVEYOR_SPEED = 1.2;
/** 충돌 카테고리. */
export const CAT = { BALL: 1, STROKE: 2, STATIC: 4, DYNAMIC: 8, GHOST: 16, ICE: 32 } as const;

export const STEP_DT = 1 / 60;
export const VELOCITY_ITER = 8;
export const POSITION_ITER = 3;
export const MAX_STEPS_PER_FRAME = 4;

/** 공이 화면 밖에 이만큼 머물면 "졌다" 힌트. */
export const LOST_AFTER = 1.5;

/** 점열 단순화(Douglas-Peucker) 허용 오차. 크면 원이 각져 보인다(사용자 지적) — 선 두께의 1/8. */
export const DP_EPSILON = 0.12 * STROKE_T;
/** 입력 샘플 최소 간격. */
export const MIN_SAMPLE_GAP = 0.25 * STROKE_T;
